import React, { useRef, useEffect } from "react";
import lottie from "lottie-web";
import styled from "styled-components";
import Animation from "../../assets/animations/menuV3.json";

const IconWrapper = styled.div`
  width: 26px;
  height: 26px;
  cursor: pointer;
  display: none;
  align-items: center;
  justify-content: center;

  svg path {
    stroke: ${(props) => props.$color} !important;
  }

  @media (max-width: 990px) {
    display: flex;
  }
`;

const IconWrapperPanel = styled.div`
  width: 26px;
  height: 26px;
  cursor: pointer;
  display: none;
  align-items: center;
  justify-content: center;

  svg path {
    stroke: ${(props) => props.$color} !important;
  }

  @media (max-width: 550px) {
    display: flex;
  }
`;

const AnimatedMenuIcon = ({ isOpen, onClick, color, panel }) => {
  const animationContainer = useRef(null);
  const animationInstance = useRef(null);

  useEffect(() => {
    if (animationContainer.current) {
      // Initialize Lottie animation
      animationInstance.current = lottie.loadAnimation({
        container: animationContainer.current,
        renderer: "svg",
        loop: false,
        autoplay: false,
        animationData: Animation,
      });

      // Set initial state
      animationInstance.current.goToAndStop(0, true);
    }

    return () => {
      if (animationInstance.current) {
        animationInstance.current.destroy();
      }
    };
  }, []);

  useEffect(() => {
    if (animationInstance.current) {
      // postavi brzinu (podesi tako da odgovara tvojoj željenoj dužini)
      animationInstance.current.setSpeed(3.3); // oko 3.3x brže ≈ 300ms

      if (isOpen) {
        animationInstance.current.setDirection(1);
        animationInstance.current.play();
      } else {
        animationInstance.current.setDirection(-1);
        animationInstance.current.play();
      }
    }
  }, [isOpen]);

  return panel ? (
    <IconWrapperPanel
      ref={animationContainer}
      onClick={onClick}
      $color={color}
    />
  ) : (
    <IconWrapper ref={animationContainer} onClick={onClick} $color={color} />
  );
};

export default AnimatedMenuIcon;
